<template>
    <span  class="d-flex justify-content-center align-items-center">
        <span v-if="value">
            <span v-if="isSheltered" class="d-flex flex-column">
                <span>
                    <b-icon icon="arrow-right" variant="success" class="mr-1"/>
                    <span>Поступил</span>
                </span>
                <span class="text-secondary">{{ shelterDate }}</span>
            </span>
            <span v-else-if="isDiscarded" class="d-flex flex-column">
                <span>
                    <b-icon icon="arrow-left" variant="danger" class="mr-1"/>
                    <span>Выбыл</span>
                </span>
                <span class="text-secondary">{{ discardDate }}</span>
                <span class="text-secondary">{{ discardReason }}</span>
            </span>
            <span v-else>
                <span class="text-secondary">Не поступал</span>
            </span>
        </span>
        <span v-else class="text-secondary"><img :src="ban"/></span>

    </span>
</template>

<script>
    import ban from '../../assets/img/ban.svg'

    export default {
        name: "AnimalShelterCell",
        props: {
            value: {}
        },
        data() {
            return {
                ban
            }
        },
        computed: {
            isSheltered() {
                return this.value['kept'] && !this.value['returned'] && this.value['alive']
            },
            isDiscarded() {
                return !this.value['alive'] || this.value['returned'];
            },
            shelterDate() {
                return this.value['shelter_date']
            },
            discardDate() {
                if (!this.value['alive']) { return this.value['death_date'] }
                if (this.value['returned']) { return this.value['return_date'] }
                return ''
            },
            discardReason() {
                if (!this.value['alive']) { return this.value['death_reason'] }
                if (this.value['returned']) { return this.value['return_target'] }
                return ''
            }
        }
    }
</script>

<style scoped>

</style>